import { css } from "simplydo/react/styled";
import { Checkbox } from "simplydo/react/ui/checkbox";
import { FormField } from "simplydo/react/ui/form";

import { FieldProps, getStringFieldOptions } from "./FieldProps";

const styledFormClass = css`
  margin-left: 15px;
`;

const OptionMultiple = ({
  field,
  fieldValue = [],
  updateIdea,
  isEditing,
}: FieldProps) => {
  const options = getStringFieldOptions(field.options);
  const selectedValues: string[] = Array.isArray(fieldValue)
    ? fieldValue.filter((value): value is string => typeof value === "string")
    : [];

  const toggleCheckbox = (option: string) => {
    if (!isEditing) return;
    const isChecked = selectedValues.indexOf(option) > -1;
    if (isChecked)
      updateIdea(
        selectedValues.filter((value) => value !== option),
        ["templated", field.id],
      );
    else updateIdea([...selectedValues, option], ["templated", field.id]);
  };

  return (
    <div className={styledFormClass}>
      {options
        .filter((option) => isEditing || selectedValues.indexOf(option) > -1)
        .map((option) => (
          <FormField key={option}>
            <Checkbox
              checked={selectedValues.indexOf(option) > -1}
              readOnly={!isEditing}
              onChange={() => toggleCheckbox(option)}
            >
              {option}
            </Checkbox>
          </FormField>
        ))}
    </div>
  );
};

export default OptionMultiple;
